import "./Footer.scss";
import {DataContextProvider} from "./DataContext";
import SearchBar from "./Components/SearchBar/SearchBar";
import LogIn from "./Components/LogIn/LogIn";
import Social from "./Components/Social/Social";
import Corporate from "./Components/Corporate/Corporate";
import SubNav from "./Components/SubNav/SubNav";
/**
- [GitHub Repository](https://github.com/turnercode/cnn-courageous-web/tree/main/src/components/component-library/src/components/common-footer)
- Figma: N/A
- [Example pg](https://www.cnn.com/)

### History
- Updated to match cnn.com - 05/2022 - NK
- Updated to match cnn.com - 01/2024 - NK
- Updated to match cnn.com - 08/2024 - NK
- Updated to meet Google's SEO compliance & to match cnn.com - 03/2025 - NK
**/
function Footer() {

  return (
    <DataContextProvider>
    <div className="footer">
      <div className="footer__contents">
        <SearchBar />
        <LogIn screenWidth="mobile" />
        <hr className="divider divider--m" />
        <SubNav origin="media" />
        <hr className="divider divider--m" />
        <SubNav origin="main" />
        <hr className="divider divider" />
        <Social origin="cnn" />
        <hr className="divider divider" />
        <Corporate />
      </div>
    </div>
    </DataContextProvider>
  );
}

export default Footer;
